import { StyledBody } from "@components/table/Table.styles";
import { IItemsRenderedEvent } from "@components/table/Table.types";
import React, { useEffect } from "react";

interface IBodyProps {
    minWidth?: number;
    isVirtualized?: boolean;
    passRef?: React.RefObject<HTMLDivElement>;
    onItemsRendered?: (props: IItemsRenderedEvent) => void;
    firstVisible?: number;
    lastVisible?: number;
}

export const Body: React.FC<IBodyProps> = React.memo(({
                                                          minWidth,
                                                          isVirtualized,
                                                          passRef,
                                                          onItemsRendered,
                                                          firstVisible,
                                                          lastVisible,
                                                          children
                                                      }) => {
    useEffect(() => {
        if ((firstVisible || lastVisible) && onItemsRendered) {
            onItemsRendered({
                visibleStartIndex: firstVisible,
                visibleStopIndex: lastVisible
            });
        }
    }, [firstVisible, lastVisible, onItemsRendered]);

    return (
            <StyledBody
                    $minWidth={minWidth}
                    ref={passRef}
                    $isVirtualized={isVirtualized}
                    role="rowgroup"
            >
                {children}
            </StyledBody>
    );
});